<template>
 <img alt="xiaoyanyun" class="zui-logo" :src="src" @click="onClick"/>
</template>
<script>
  import '../../assets/less/logo.less'
  import logo from '../../assets/img/logo.png'
  export default {
    name: 'Logo',
    props: {
      type: {
        default: 'xiaoyanyun'
      },
      href: {
        default: '/'
      }
    },
    computed: {
      src() {
        if (this.type === 'xiaoyanyun') {
         return logo
        }
        return ""
      }
    },
    methods: {
      onClick() {
        if(this.type==="xiaoyanyun"){
           location.assign(this.href)
        }
      }
    }
  }
</script>
